var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-background"},[(_vm.isLoading)?_c('div',{staticClass:"loader"},[_c('b-spinner',{attrs:{"label":"Loading...","variant":"primary"}}),_c('p',[_vm._v("Loading..")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }